import React from 'react';
import { StyleSheet, View } from 'react-native';
import { TabBar } from 'react-native-tab-view';
import { colors, fontSizes, dimensions } from '../../styles';
import Text from './Text';
import { getCurrentTheme } from '../../templates';

const s = StyleSheet.create({
  tabBar: {
    backgroundColor: colors.white,
    height: 48,
  },
  tab: {
    justifyContent: 'flex-end',
  },
  indicator: {
    borderBottomWidth: 2,
  },
  indicatorContainer: {
    borderBottomWidth: 1,
    borderColor: colors.grayBorder,
  },
  label: {
    padding: 0,
    margin: 0,
    fontFamily: 'Rubik-Regular',
    fontSize: fontSizes.small,
  },

  badgeContainer: {
    height: 18,
    minWidth: 18,
    paddingHorizontal: 3,
    borderRadius: 4,
    marginHorizontal: dimensions.halfMedium,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default ({ ...props }) => {
  const currentTheme = getCurrentTheme();
  return (
    <TabBar
      getLabelText={({ route }) => route.title}
      style={s.tabBar}
      tabStyle={s.tab}
      indicatorStyle={[
        s.indicator,
        {
          backgroundColor: currentTheme.colors.secondary,
          borderBottomColor: currentTheme.colors.secondary,
        },
      ]}
      indicatorContainerStyle={s.indicatorContainer}
      labelStyle={s.label}
      inactiveColor={colors.gray}
      activeColor={currentTheme.colors.secondary}
      {...props}
    />
  );
};

export const Badge = ({ count }) => {
  const currentTheme = getCurrentTheme();
  if (!count) {
    return null;
  }
  return (
    <View style={[s.badgeContainer, { backgroundColor: currentTheme.colors.secondary }]}>
      <Text color={colors.white} xsmall>
        {count}
      </Text>
    </View>
  );
};

export const BadgeOld = ({ isPersonal }) => (
  <View
    style={{
      height: 10,
      marginTop: 8,
      marginRight: isPersonal ? 6 : 20,
      width: 10,
      borderRadius: 5,
      backgroundColor: colors.red,
    }}
  />
);
